import { View, Text, Image } from '@react-pdf/renderer'
import React from 'react'

const MeasureBox = ({
    image,
    title,
    critical,
    major,
    minor,
    viewStyles={}
}) => {
  return (
    <>
    <View
        style={{
            width: "33.333%",
            borderWidth: "1px",
            borderColor: "#000",
            flexDirection: "row",
            ...viewStyles,
        }}
        >
            <View
                style={{
                    width: "25%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "5px 1px",
                    backgroundColor: "#666666",
                    borderRightWidth: "1px",
                    borderRightColor: "#000"
                }}
            >
                <Image 
                    src={image}
                    style={{
                        width: "15px",
                        marginBottom: "3px"
                    }}
                />
                <Text 
                    style={{
                        fontSize: "7px",
                        color: "#fff",
                        textAlign: "center"
                    }}
                >
                    {title ? title : "-"}
                </Text>
            </View>
            <View
                style={{
                    width: "25%",
                    borderRightWidth: "1px",
                    borderRightColor: "#000"
                }}
            >
                <View
                    style={{
                        padding: "10px 5px",
                        justifyContent: "center",
                        alignContent: "center",
                        display: "flex",
                        borderBottomWidth: "1px",
                        borderBottomColor: "#000",
                        backgroundColor: "#fff",
                    }}
                >
                <Text 
                    style={{
                        fontSize: "7px",
                        color: "#000",
                        textAlign: "center",
                        fontStyle: "italic"
                    }}
                >
                    CRITICAL
                </Text>
                </View>
                <View
                    style={{
                        padding: "10px 5px",
                        justifyContent: "center",
                        alignContent: "center",
                        display: "flex",
                        backgroundColor: "#fff",
                    }}
                >
                <Text 
                    style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                        color: "#000",
                        textAlign: "center"
                    }}
                >
                    {critical ? critical : "-"}
                </Text>
                </View>
            </View>
            <View
                style={{
                    width: "25%",
                    borderRightWidth: "1px",
                    borderRightColor: "#000"
                }}
            >
                <View
                    style={{
                        padding: "10px 5px",
                        justifyContent: "center",
                        alignContent: "center",
                        display: "flex",
                        borderBottomWidth: "1px",
                        borderBottomColor: "#000",
                        backgroundColor: "#fff",
                    }}
                >
                <Text 
                    style={{
                        fontSize: "7px",
                        color: "#000",
                        textAlign: "center",
                        fontStyle: "italic"
                    }}
                >
                    MAJOR
                </Text>
                </View>
                <View
                    style={{
                        padding: "10px 5px",
                        justifyContent: "center",
                        alignContent: "center",
                        display: "flex",
                        backgroundColor: "#fff",
                    }}
                >
                <Text 
                    style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                        color: "#000",
                        textAlign: "center"
                    }}
                >
                    {major ? major : "-"}
                </Text>
                </View>
            </View>
            <View
                style={{
                    width: "25%",
                }}
            >
                <View
                    style={{
                        padding: "10px 5px",
                        justifyContent: "center",
                        alignContent: "center",
                        display: "flex",
                        borderBottomWidth: "1px",
                        borderBottomColor: "#000",
                        backgroundColor: "#fff",
                    }}
                >
                <Text 
                    style={{
                        fontSize: "7px",
                        color: "#000",
                        textAlign: "center",
                        fontStyle: "italic"
                    }}
                >
                    MINOR
                </Text>
                </View>
                <View
                    style={{
                        padding: "10px 5px",
                        justifyContent: "center",
                        alignContent: "center",
                        display: "flex",
                        backgroundColor: "#fff",
                    }}
                >
                <Text 
                    style={{
                        fontSize: "10px",
                        fontWeight: "bold",
                        color: "#000",
                        textAlign: "center"
                    }}
                >
                    {minor ? minor : "-"}
                </Text>
                </View>
            </View>



        </View>
    </>
  )
}

export default MeasureBox